<template>
  <div class="reservation-form-custom-hour">
    <message type="warning" v-pure-html="$t('reservationFormCustomHour.warning')"></message>

    <field slot="content">
      <label slot="label">{{ $t('reservationFormCustomHour.selectTerm') }}</label>
      <date-picker
        slot="field"
        :language="$t('common.ui.datepickerLanguage')"
        :full-month-name="true"
        ref="date-picker"
        :value="date"
        @selected="changeDate"
        :format="$t('common.ui.datepickerFormat')"
        :monday-first="true"></date-picker>
    </field>

    <field
      v-if="!useDaysMode"
      slot="content">
      <label slot="label">{{ $t('reservationFormCustomHour.selectTermHour') }}</label>
      <select
        slot="field"
        class="small-select"
        v-model="hours">
        <option
          v-for="(i, index) of Array(24)"
          :key="'select-h-' + ~~i + '-' + index"
          :value="outputValue(index)">
          {{ outputValue(index) }}
        </option>
      </select>

      <select
        slot="field"
        class="small-select"
        v-model="minutes">
        <option
          v-for="(i, index) of Array(12)"
          :key="'select-m-' + ~~i + '-' + index * 5"
          :value="outputValue(index * 5)">
          {{ outputValue(index * 5) }}
        </option>
      </select>
    </field>

    <btn
      type="medium success"
      @click.native="setCustomDateTime()">
      {{ $t('reservationFormCustomHour.setTerm') }}
    </btn>

    <p
      v-if="showDateNotice"
      class="text-center text-danger">
      {{ $t('reservationFormCustomHour.youHaveToSelectDate') }}
    </p>

    <p
      v-if="changeDatePopupMode && this.parent.selectedDate.date"
      :class="{
        'text-center': true,
        'text-danger': !checkTermStatus && !checkTermLoading,
        'text-success': checkTermStatus && !checkTermLoading
      }">
      {{ $t('reservationFormCustomHour.selectedTerm') }}
      <strong>
        {{ this.parent.selectedDate.date }}
        <template v-if="!useDaysMode">
          {{ $t('reservationFormCustomHour.selectedHour') }} {{ this.parent.hour }}
        </template>
      </strong>
      <span
        v-if="checkTermMessage && !checkTermLoading"
        class="check-term-message"
        v-pure-html="checkTermMessage"
        style="display: block;">
      </span>
    </p>
  </div>
</template>

<script>
import Configuration from './../mixins/Configuration';
import DatePicker from 'vuejs-datepicker';
import ErrorUtils from './../helpers/ErrorUtils.js';
import Vue from 'vue';

export default {
  name: 'reservation-form-custom-hour',
  mixins: [
    Configuration
  ],
  components: {
    'date-picker': DatePicker
  },
  props: [
    'changeDatePopupMode',
    'selectedWorker',
    'useDaysMode',
    'checkTermMode',
    'reservationData'
  ],
  data () {
    return {
      hours: '00',
      minutes: '00',
      date: '',
      parent: this.changeDatePopupMode ? this.$parent : this.$parent.$parent,
      showDateNotice: false,
      // check term
      checkTermLoading: false,
      checkTermStatus: true,
      checkTermMessage: ''
    };
  },
  mounted () {
    if (
      this.parent.usesCustomHour &&
      this.parent.selectedDate.date !== ''
    ) {
      if (!this.useDaysMode) {
        let time = this.parent.selectedDate.hour;

        if (time !== '') {
          time = time.split(':');
          this.hours = time[0];
          this.minutes = time[1];
        }
      }

      this.date = this.parent.selectedDate.date;

      if (this.changeDatePopupMode && this.date) {
        this.checkTerm();
      }
    }
  },
  methods: {
    changeDate (newValue) {
      let month = newValue.getMonth() + 1.0;
      let day = newValue.getDate();

      if (month < 10) {
        month = '0' + month;
      }

      if (day < 10) {
        day = '0' + day;
      }

      this.date = [newValue.getFullYear(), month, day].join('-');
      this.showDateNotice = false;
    },
    setCustomDateTime () {
      if (this.date) {
        this.parent.selectedDate.date = this.date;

        if (!this.useDaysMode) {
          this.parent.selectedDate.hour = this.hours + ':' + this.minutes;
        }

        if (this.selectedWorker) {
          this.parent.selectedDate.worker = this.selectedWorker;
        }
      } else {
        this.showDateNotice = true;
      }

      Vue.nextTick(() => {
        if (this.changeDatePopupMode && this.date) {
          this.checkTerm();
        }
      });
    },
    outputValue (value) {
      return value < 10 ? '0' + value : value;
    },
    checkTerm () {
      let config = {};
      this.checkTermLoading = true;

      if (this.checkTermMode !== 'copy-reservation') {
        config.inquiry_id = parseInt(this.reservationData.id, 10);
      }

      if (this.reservationData.confirm_email !== '') {
        config.email = this.reservationData.confirm_email;
      }

      if (this.reservationData.phone !== '') {
        config.phone = this.reservationData.phone;
      }

      if (this.reservationData.people_number !== '') {
        config.people = this.reservationData.people_number;
      }

      if (this.reservationData.service) {
        config.service = this.reservationData.service.id;
      }

      if (this.workersEnabled && this.reservationData.worker) {
        config.worker = this.reservationData.worker.id;
      }

      config.date = this.parent.selectedDate.date;
      config.start_date = this.parent.selectedDate.date;
      config.plugin_comment = this.reservationData.plugin_comment;

      let endpoint = '/panel/reservations/check-hourly-date';

      if (this.useDaysMode) {
        endpoint = '/panel/reservations/check-daily-date';
        config.days = this.parent.selectedDate.days;

        if (this.reservationData.children) {
          config.children = this.reservationData.children;
        } else {
          config.children = 0;
        }
      } else {
        config.modified_time_increaser = 5;
        config.duration = this.reservationData.duration;
        config.hour = this.parent.selectedDate.hour;
      }

      this.checkTermMessage = '';
      this.checkTermStatus = true;

      this.$http.post(endpoint, config).then(response => {
        if (!response.data.data.length) {
          this.checkTermMessage = response.data.message;
          this.checkTermStatus = false;
        }

        if (this.useDaysMode) {
          this.checkTermMessage = response.data.data.details.message;
          this.checkTermStatus = !!response.data.data.details.available;
        } else {
          this.checkTermMessage = response.data.data.message;
          this.checkTermStatus = !!response.data.data.valid;
        }

        this.checkTermLoading = false;
      }).catch(error => {
        ErrorUtils.handleSubmitError(error, endpoint, this.$router, this.$bus, this.checkTerm.bind(this));
        this.checkTermLoading = false;
        this.checkTermMessage = '';
        this.checkTermStatus = false;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.reservation-form-custom-hour {
  display: block;
  width: 100%;

  .field {
    max-width: 320px;

    label {
      width: 140px;
    }

    .small-select {
      width: 7.5rem;

      & + .small-select {
        margin-left: 1rem;
      }
    }
  }

  .button {
    margin: 20px auto 0 auto;
    justify-content: center;
    width: 290px;
  }

  .message {
    max-width: 640px;
  }

  .check-term-message /deep/ ul {
    display: flex;
    list-style-type: none;
    justify-content: center;
    flex-direction: column;
    margin: 10px 0 0 0;
    padding: 0;

    li {
      text-align: center;
    }
  }
}

@media (max-width: 400px) {
  .reservation-form-custom-hour {
    display: block;
    width: 100%;

    .field {
      max-width: 320px;

      label {
        width: 100px;
      }

      .small-select {
        width: 7.5rem;

        & + .small-select {
          margin-left: 1rem;
        }
      }
    }

    .button {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ReservationFormCustomHour.vue